<template>
<section class="call">
  <div class="call-body">
    <header class="call-body__header">
      <button class="close" @click="callClose ()"><span></span></button>
    </header>
    <form class="call-body__content">
      <fieldset v-if="callStat === 1">
        <legend>Обратный звонок</legend>
        <div class="input-group">
          <input type="text" id="text-3" placeholder="Ваше имя">
          <label for="text-3"></label>
        </div>
        <div class="input-group">
          <input type="text" id="text-4" placeholder="Номер телефона">
          <label for="text-4"></label>
        </div>
        <button class="button__yellow button_small" @click="callPlus ()">
          Позвонить мне
        </button>
      </fieldset>
      <div class="text" v-if="callStat === 2">
        Спасибо за заявку!
        <button class="button__transparent button_small" @click="closeCall">Закрыть</button>
      </div>
    </form>
  </div>
  <div class="call-bg">

  </div>
</section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'SectionCall',
  components: {},
  methods: {
    ...mapActions (['closeCall', 'plusCall']),
    callClose () {
      this.closeCall()
    },
    callPlus () {
      this.plusCall()
    }
  },
  computed: {
    ...mapGetters(['callStat'])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.call {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
  &-body {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    width: 80vw;
    min-width: 300px;
    height: 80vh;
    min-height: 300px;
    background-color: #fff;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    padding: 50px 100px;
    @media (max-width: 1199.98px) {
      width: 100%;
      height: 100%;
      overflow: scroll;
      padding: 30px 10px;
    }
    .close {
      position: relative;
      top: 0;
      right: 0;
      width: 30px;
      height: 30px;
      padding: 0;
      span {
        position: relative;
        width: 100%;
        height: 100%;
        content: '';
        display: block;
        top: 0;
        right: 0;
        &:after, &:before {
          position: absolute;
          width: 30px;
          height: 2px;
          content: '';
          background-color: #000000;
          top: 50%;
          right: 0;
        }
        &:after {
          transform: rotate(45deg);
        }
        &:before {
          transform: rotate(-45deg);
        }
      }
    }
    &__header {
      margin-bottom: 20px;
      display: flex;
      justify-content: flex-end;
    }
    &__content {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex: 1 1 auto;
      fieldset {
        display: flex;
        flex-direction: column;
        @media (max-width: 575.98px) {
          width: 100%;
        }
        .input-group {
          margin-top: 20px;
          input[type="text"] {
            border: 1px solid #E0E0E0;
            box-sizing: border-box;
            font-weight: 300;
            font-size: 1.6rem;
            color: #0E0E0E;
            padding: 15px 20px;
            height: auto;
            width: 500px;
            @media (max-width: 575.98px) {
              width: 100%;
            }
            &::placeholder {
              font-weight: 200;
              font-size: 1.6rem;
              color: #4F4F4F;
            }
          }
        }
        button {
          margin-top: 30px;
          font-size: 1.6rem;
          font-weight: 300;
          width: 500px;
          @media (max-width: 575.98px) {
            width: 100%;
          }
        }
      }
      legend {
        font-size: 2.4rem;
        margin-bottom: 20px;
      }
      .text {
        font-size: 3rem;
        font-weight: 300;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        button {
          margin-top: 30px;
        }
      }
    }
  }
  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: .6;
  }
}
</style>
